import { consume as e } from "./lib/consume.es.js";
import { consumes as t } from "./lib/consumes.es.js";
import { TTVisualWrapper as n } from "./components/TTVisualWrapper.es.js";
import { TTVisualImage as r } from "./components/TTVisualImage.es.js";
import { TTVisualByline as i } from "./components/TTVisualByline.es.js";
import { TTVisualText as a } from "./components/TTVisualText.es.js";
import "./components/index.es.js";
import { normalizeTTVisual as o } from "./lib/normalizeTTVisual.es.js";
//#region lib/TTVisual/index.tsx
var s = (s) => ({
	class: "block",
	name: "tt/visual",
	consumer: {
		consumes: t,
		consume: e
	},
	options: s,
	componentEntry: {
		component: n,
		constraints: { normalizeNode: o },
		class: "block",
		children: [
			{
				type: "image",
				class: "void",
				component: r,
				constraints: {
					min: 1,
					max: 1
				}
			},
			{
				type: "text",
				class: "text",
				component: a,
				constraints: {
					allowBreak: !1,
					min: 1,
					max: 1
				}
			},
			{
				type: "byline",
				class: "text",
				component: i,
				constraints: {
					allowBreak: !1,
					min: 1,
					max: 1
				}
			}
		]
	}
});
//#endregion
export { s as TTVisual };
